<main>
    <div class="accueil_left">
        <app-menus></app-menus>
    </div>
    <div class="accueil_right">
        <div class="home_bg"></div>
        <div class="accueil_stars_ctn">
          <h2>{{userStars}}</h2>
          <span class="material-icons">grade</span>
          <div class="vl"></div>
          <div *ngIf="activeEvents == true" class="temps_fort_ctn blink_me">
            <div class="temps_fort">
              <h2>{{userTempsFort}}</h2>
              <span class="material-icons">grade</span>
            </div>
            <h3>Temps fort</h3>
          </div>
        </div>
        <div class="card">
            <h4>Pourquoi et comment participer aux Étoiles d’Acajoux?</h4>
            <div class="card_content">
              Les Étoiles d’Acajoux ont été créés pour faire bouger les jeunes francophones.
              <br>Les activités peuvent être faites : 
              <ul>
                <li>Seul(e)</li>
                <li>En famille</li>
                <li>Avec ta classe</li>
              </ul>Tu peux en parler autour de toi pour faire participer le plus de personnes possible.
              <br>Les activités sont libres : Fais ce que tu AIMES !
            </div>
          </div>
          <div class="card">
            <h4>Comment fonctionnent les Étoiles d’Acajoux? </h4>
            <div class="card_content">
              Pour avoir une Étoile sur ton compteur, tu dois avoir fait une pratique de 15 minutes.
              Ta pratique peut être :
              <ul>
                <li>Sportive (Vélo, soccer, celle qui te fait plaisir…)</li>
                <li>Culturelle (Chant, théâtre, celle qui te fait plaisir…)</li>
              </ul>
              Alors fais ton choix, accumule tes Étoiles et Amuse-toi bien seul(e) ou accompagné(e)! 
            </div>
          </div>
    </div>
</main>